<template>
  <div v-show="isVehicleInformationOpen" class="vehicle-information">
    <div class="vehicle-information__top">
      <h3 class="vehicle-information__header">
        {{ header }}
      </h3>

      <button class="vehicle-information__close-action" @click="toggleValue({ key: 'isVehicleInformationOpen', data: false })">
        {{ tStatic('closeLink') }}
      </button>
    </div>

    <div class="vehicle-information__content-container">
      <div v-if="imageUrl" class="vehicle-information__image-container">
        <img :src="imageUrl" :alt="header" class="vehicle-information__image">
      </div>

      <div class="vehicle-information__table">
        <div v-for="item of informationRows" :key="item.key" class="vehicle-information__row">
          <div class="vehicle-information__key">
            {{ item.key }}
          </div>
          <div class="vehicle-information__value">
            {{ item.value }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    header: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: false,
      default: ''
    },
    informationRows: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters('ui', ['isVehicleInformationOpen'])
  },
  methods: {
    ...mapActions('ui', ['toggleValue'])
  }
}
</script>

<style lang="scss">
.vehicle-information {
  background-color: color(background-blue-4);
  border: 1px solid color(border-blue-3);
  padding: measure(half);
  margin-bottom: measure(full);
}

.vehicle-information__top {
  display: flex;
  flex-direction: column;
  margin-bottom: measure(half);

  @include media(x-small) {
    flex-direction: row;
    align-items: center;
  }
}

.vehicle-information__header {
  @include body-smaller-semi-bold;
  order: 2;
  margin: 0;

  @include media(x-small) {
    order: 0;
    @include body-semi-bold;
  }
}

.vehicle-information__close-action {
  @include body-smaller;
  order: 0;
  margin-bottom: measure(quarter);
  margin-left: auto;
  background-color: transparent;
  border: none;
  cursor: pointer;

  @include media(x-small) {
    order: 2;
    margin-bottom: 0;
  }

  &:hover {
    text-decoration: underline;
  }
}

.vehicle-information__close-button-text {
  display: none;

  @include media(small) {
    display: inline-block;
  }
}

.vehicle-information__close-button > svg {
  width: 1.875rem;
  height: 1.875rem;
  margin-left: measure(quarter);
}

.vehicle-information__content-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @include media(medium) {
    flex-direction: row;
  }
}

.vehicle-information__image-container {
  width: 100%;
  margin-bottom: measure(half);
  padding: measure(quarter);
  background-color: color(background-blue-6);
  border: 1px solid color(border-blue-3);

  @include media(medium) {
    width: 40%;
    margin-right: measure(full);
    margin-bottom: 0;
    padding: measure(half);
  }
}

.vehicle-information__image {
  width: 100%;
}

.vehicle-information__table {
  flex-grow: 1;
  background-color: color(background-blue-6);
  border: 1px solid color(border-blue-3);
  border-bottom: 0;
}

.vehicle-information__row {
  display: flex;
  flex-direction: column;
  padding: measure(quarter) measure(half);
  border-bottom: 1px solid color(border-blue-3);

  @include media(small) {
    flex-direction: row;
  }
}

.vehicle-information__key {
  @include body-smaller-semi-bold;
  flex-shrink: 0;
  width: 7rem;
  margin-bottom: measure(quarter);

  @include media(small) {
    width: 11rem;
    margin-bottom: 0;
  }
}

.vehicle-information__value {
  @include body-smaller;
}
</style>
